import utils from "./utils";
import axios from "axios";
import endpoints from "../utils/endpoints";

export default class Auth {
  constructor(api) {
    this.api = api;
  }

  login(data, onSuccess, onError) {
    return this.api.http_fibercloud
      .post("v1/auth", data)
      .then(resp => {
        onSuccess(resp);
      })
      .catch(error => {
        onError(error);
      });
  }

  logout(onSuccess, onError) {
    // Call v3-app logout endpoint to clear session
    // Use v3_auth_token if available (for when auth_token has expired)
    // Fallback to auth_token if v3_auth_token is not available
    const v3Token = localStorage.getItem("v3_auth_token");
    const authToken = localStorage.getItem("auth_token");
    const tokenToUse = v3Token || authToken;
    
    // Create a one-time request with the appropriate token
    // This bypasses the http_fibercloud instance which uses auth_token
    return axios.post(
      `${endpoints.FIBER_API_URL}session/end`,
      {},
      {
        headers: {
          Authorization: tokenToUse ? `Bearer ${tokenToUse}` : undefined
        },
        withCredentials: true
      }
    )
      .then(resp => {
        if (onSuccess) {
          onSuccess(resp);
        }
      })
      .catch(error => {
        // Even if the API call fails, we should still proceed with logout
        // This ensures logout works even if the server is unreachable
        if (onError) {
          onError(error);
        }
      });
  }

  getCredentials(onSuccess, onError) {
    return this.api.http_fibercloud
      .get("v1/mycredentials")
      .then(resp => {
        onSuccess(resp);
      })
      .catch(error => {
        onError(error);
      });
  }

  getDetails(onSuccess, onError) {
    return this.api.http_fibercloud
      .get("v1/mydetails")
      .then(resp => {
        onSuccess(resp);
      })
      .catch(error => {
        onError(error);
      });
  }

  workspacesByUserAndCompany(onSuccess, onError) {
    return this.api.http_fibercloud
      .get("v1/workspacesbyuserandcompany", {
        headers: {
          companyuuid: utils.getCompanyUUID()
        }
      })
      .then(resp => {
        onSuccess(resp);
      })
      .catch(error => {
        onError(error);
      });
  }

  rolesByUserAndCompany(onSuccess, onError) {
    return this.api.http_fibercloud
      .get("v1/rolesbyuserandcompany", {
        headers: {
          companyuuid: utils.getCompanyUUID()
        }
      })
      .then(resp => {
        onSuccess(resp);
      })
      .catch(error => {
        onError(error);
      });
  }
}



// WEBPACK FOOTER //
// ./src/api/auth.js